document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.open-ai-mike-chat');
  if (!trigger) return;

  e.preventDefault();
  e.stopPropagation();

  const widget = document.querySelector('#rogue-chatbot-widget');
  const root = widget?.shadowRoot;

  if (!root) {
    console.warn('Rogue chat shadowRoot not found.');
    return;
  }

  const launcher =
    root.querySelector('.ra-launcher') ||
    root.querySelector('.ra-bubble') ||
    root.querySelector('.ra-button') ||
    root.querySelector('button[aria-label*="chat" i]') ||
    root.querySelector('button[aria-label*="open" i]') ||
    root.querySelector('button');

  if (launcher) {
    launcher.click();
  } else {
    console.warn('Rogue chat launcher button not found.');
  }
}, true);